module.exports = __webpack_public_path__ + "static/media/step1_j.e08f8ebd.png";